import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import {
  formatEnTimeByStr,
  fixLineData,
  computePrecentChange,
} from '@/pages/intelligence/pages/MarketProfile/_util';
import { formatNum, formatPercentNum } from '@/pages/intelligence/utils/commonUtils';
import * as echarts from 'echarts';
import { history } from 'umi';
import MarketProfileDetailsInsightsAdapter, { formatMobileNewReleaseGames } from '../Insights/adapter';

const getPageData = (url: string, params: any): Promise<any> => {
  return MarketProfileDetailsInsightsAdapter.getPageData(url, params);
};

export default function useInsightsModal(props: any) {
  const { countryId, marketName, marketNameEn, pageId, segment, changeSegment, setActiveId } =
    props;
  const [SegmentValue, setSegmentValue] = useState('mobile');
  const [dateValue, setDateValue] = useState([]);
  const [dataSource, setDataSource] = useState('sensortower');
  // Trend 部分的数据
  const [trendLoad, setTrendLoad] = useState(true);
  const [trendLoadDetail, setTrendLoadDetail] = useState(false);
  const [lineData, setLineData] = useState([]);
  const [trendTime, setTrendTime] = useState('');
  const [gameTop101, setGameTop101] = useState([]);
  const [gameTop102, setGameTop102] = useState([]);
  const [hasLineData, setHasLineData] = useState(true);
  const [hasCr10Data, setHasCr10Data] = useState(true);
  // 折线图的时间范围，用于跳转到stats传参
  const [lineChartDate, setLineChartDate] = useState(['', '']);

  // Big Riser部分数据
  const [riserTime, setRiserTime] = useState('');
  const [riserData, setRiserData] = useState([]);
  const [riserLoad, setRiserLoad] = useState(true);

  // New Release 部分数据
  const [relaseTime, setReleaseTime] = useState('');
  const [relaseData, setReleaseData] = useState([]);
  const [relaseLoad, setReleaseLoad] = useState(true);

  // Upcoming 部分数据
  const [upcomingTime, setUpcomingTime] = useState('');
  const [upcomingData, setUpcomingData] = useState([]);
  const [upcomingLoad, setUpcomingLoad] = useState(true);

  const [timeCache, setTimeCache] = useState({
    mobile: '',
    pc: '',
    console: '',
  });

  // 根据各个模块最新时间设置显示时间
  const changeDefaultTime = (time) => {
    let timeD = dateValue[0];
    if (dateValue.length == 0) {
      timeD = time;
    } else {
      const diff =
        new Date(time.split('-').join('/')).getTime() -
        new Date(timeD.split('-').join('/')).getTime();
      if (diff < 0) {
        timeD = time;
      }
    }

    dateValue.length = 0;
    dateValue.push(...[timeD]);
    setDateValue(dateValue);
  };

  // CR10 Trends 数据查询
  const cr10TrendSearch = async (param: any, flag = true) => {
    setTrendLoad(true);
    setHasLineData(false);
    setHasCr10Data(true);
    // let trendRes = await getPageData('detail/insights_cr10/trend?cacheRefresh=true', param);
    const trendRes = await getPageData('detail/insights_cr10/trend', param);
    let revenueTotal = 0;
    if (trendRes) {
      const trendData = trendRes.market_cr_10_rev_trend;
      const lineDealData = {
        xAxis: [],
        series: [],
      };
      let revMax = 0;
      const temp = {};
      if (trendData) {
        // 设置折线图时间范围
        setLineChartDate([trendData[0]?.date, trendData[trendData.length - 1]?.date]);
        const xAxis = [];
        let lineData = [];
        let barData = [];

        if (flag) {
          changeDefaultTime(trendRes.end_date);
          setTrendTime(trendRes.end_date);
        }

        trendData.map((item, key) => {
          xAxis.push(item.date);
          barData = fixLineData(barData, key);
          const cr10Rev = item.cr10_rev || 0;
          barData.push(cr10Rev == 0 ? '-' : cr10Rev.toFixed(2));
          const revData = item.rev || 0;
          lineData = fixLineData(lineData, key);
          lineData.push(revData == 0 ? '-' : cr10Rev == 0 ? '-' : cr10Rev / revData);
          if (revMax < cr10Rev) {
            revMax = cr10Rev;
          }
          if (flag && key == trendData.length - 1) {
            revenueTotal = revData;
          } else {
            if (param.end_date == item.date) {
              revenueTotal = revData;
            }
          }
        });

        const chartData = [
          {
            name: 'CR10',
            type: 'bar',
            data: barData,
            color: '#376AE7',
            emphasis: {
              itemStyle: {
                color: '#376AE7',
              },
            },
          },
          {
            name: 'CR10 in %',
            type: 'line',
            yAxisIndex: 1,
            color: '#4FCB87',
            data: lineData,
          },
        ];

        lineDealData.xAxis = xAxis;
        lineDealData.series = chartData;
        setHasLineData(true);
      }
      // lineChart(lineDealData, revMax);
      setLineData(lineDealData);

      const tableData = trendRes.market_cr_10_games;
      const topData1 = [];
      const topData2 = [];
      let sum = 0;
      if (tableData) {
        tableData.map((item, index) => {
          const obj = {
            id: item.app_id,
            rank: index + 1,
            name: item.name,
            gameIcon: item.cover,
            desc: item.publisher,
            revenue: item.rev.toFixed(2),
            precent: revenueTotal == 0 ? 0 : item.rev / revenueTotal,
            conutryFlag: item.country_img,
            conutryName: `${item.location_city} ,${item.location_country}`,
            platList: item.platform?.split('|') || [],
          };
          if (index < 5) {
            topData1.push(obj);
          } else if (index >= 5 && index < 10) {
            topData2.push(obj);
          }
          sum += item.rev;
        });
      } else {
        if (lineDealData?.xAxis?.length == 0) {
          setHasCr10Data(false);
        }
      }
      setGameTop101(topData1);
      setGameTop102(topData2);
    } else {
      setHasCr10Data(false);
    }
    setTrendLoad(false);
  };

  const cr10DetailSearch = async (param: any) => {
    setTrendLoadDetail(true);
    const trendDetailRes = await getPageData('detail/insights_cr10/trend/detail', param);
    const topData1 = [] as any;
    const topData2 = [] as any;
    if (trendDetailRes) {
      const tableData = trendDetailRes.market_cr_10_games;
      if (tableData) {
        const revenueTotal = trendDetailRes.rev_total || 0;
        tableData.map((item, index) => {
          const obj = {
            id: item.app_id,
            rank: index + 1,
            name: item.name,
            gameIcon: item.cover,
            desc: item.publisher,
            revenue: item.rev.toFixed(2),
            precent: revenueTotal == 0 ? 0 : item.rev / revenueTotal,
            conutryFlag: item.country_img,
            conutryName: `${item.location_city} ,${item.location_country}`,
            platList: item.platform?.split('|') || [],
          };
          if (index < 5) {
            topData1.push(obj);
          } else if (index >= 5 && index < 10) {
            topData2.push(obj);
          }
        });
      }
    }
    setGameTop101(topData1);
    setGameTop102(topData2);
    setTrendLoadDetail(false);
  };

  // Big Riser 数据查询
  const bigRiserSearch = async (param: any, flag = true) => {
    try {
      setRiserLoad(true);
      // let bigRiserRes = await getPageData('detail/insights_bigriser2?cacheRefresh=true', param);
      const bigRiserRes = await getPageData('detail/insights_bigriser2', param);
      const tempData = [];
      if (bigRiserRes && bigRiserRes.big_riser_games) {
        const riserDataT = bigRiserRes.big_riser_games;
        riserDataT.map((item) => {
          if (param.entity_type == 'mobile') {
            // riser_tips处理
            const topFreeTips = [];
            const topGrossingTips = [];
            const topPaidTips = [];
            const riserTips = item.big_riser_tips;
            if (riserTips) {
              riserTips.map((v) => {
                if (v.chart_type.toLowerCase().indexOf('free') != -1) {
                  topFreeTips.push(v.rank_type);
                } else if (v.chart_type.toLowerCase().indexOf('grossing') != -1) {
                  topGrossingTips.push(v.rank_type);
                } else if (v.chart_type.toLowerCase().indexOf('paid') != -1) {
                  topPaidTips.push(v.rank_type);
                }
              });
            }
            // 处理top_free、top_grossing、top_paid的数据及环比
            let topFree = 0;
            let topFreeChange = 0;
            let topGrossing = 0;
            let topGrossingChange = 0;
            let topPaid = 0;
            let topPaidChange = 0;
            const rankInfo = item.big_riser_rank;
            if (rankInfo) {
              const preRankInfo = item.pre_big_riser_rank;
              rankInfo.map((v) => {
                const value = v.rank_value;
                let preValue = 0;
                preRankInfo?.map((o) => {
                  if (o.rank_key == v.rank_key) {
                    preValue = o.rank_value;
                  }
                });
                if (v.rank_key.toLowerCase().indexOf('free') != -1) {
                  topFree = value;
                  if (value != 0) {
                    topFreeChange = preValue - value;
                  }
                } else if (v.rank_key.toLowerCase().indexOf('grossing') != -1) {
                  topGrossing = value;
                  if (value != 0) {
                    topGrossingChange = preValue - value;
                  }
                } else if (v.rank_key.toLowerCase().indexOf('paid') != -1) {
                  topPaid = value;
                  if (value != 0) {
                    topPaidChange = preValue - value;
                  }
                }
              });
            }
            const obj = {
              rank: item.rank,
              name: item.name,
              gameIcon: item.cover,
              desc: item.publisher,
              top_free: topFree,
              top_grossing: topGrossing,
              top_paid: topPaid,
              top_free_change: topFreeChange,
              top_grossing_change: topGrossingChange,
              top_paid_change: topPaidChange,
              topFreeTips,
              topGrossingTips,
              topPaidTips,
              id: item.app_id,
              countryId: history.location.query.marketNameEn,
              conutryFlag: item.country_img,
            };
            tempData.push(obj);
          } else if (param.entity_type == 'pc') {
            // riser_tips处理
            const msRevenueTips = [] as any;
            const newzooTips = [] as any;
            const trendingTips = [] as any;
            const sellerTips = [] as any;
            const epicTips = [] as any;
            const riserTips = item.big_riser_tips;
            if (riserTips) {
              riserTips.map((v) => {
                if (v.chart_type.toLowerCase().indexOf('mscience') != -1) {
                  msRevenueTips.push(v.rank_type);
                } else if (v.chart_type.toLowerCase().indexOf('newzoo') != -1) {
                  newzooTips.push(v.rank_type);
                } else if (v.chart_type.toLowerCase().indexOf('trending') != -1) {
                  trendingTips.push(v.rank_type);
                } else if (v.chart_type.toLowerCase().indexOf('sellers') != -1) {
                  sellerTips.push(v.rank_type);
                } else if (v.chart_type.toLowerCase().indexOf('popular') != -1) {
                  epicTips.push(v.rank_type);
                }
              });
            }
            // 处理 mscience newzoo trending sellers popular 的数据及环比
            let mscience = 0;
            let mscienceChange = 0;
            let newzoo = 0;
            let newzooChange = 0;
            let trending = 0;
            let trendingChange = 0;
            let sellers = 0;
            let sellersChange = 0;
            let popular = 0;
            let popularChange = 0;

            const rankInfo = item.big_riser_rank;
            if (rankInfo) {
              const preRankInfo = item.pre_big_riser_rank;
              rankInfo.map((v) => {
                const value = v.rank_value;
                let preValue = 0;
                preRankInfo?.map((o) => {
                  if (o.rank_key == v.rank_key) {
                    preValue = o.rank_value;
                  }
                });
                if (v.rank_key.toLowerCase().indexOf('mscience') != -1) {
                  mscience = value;
                  if (value != 0) {
                    mscienceChange = computePrecentChange(value, preValue);
                  }
                } else if (v.rank_key.toLowerCase().indexOf('newzoo') != -1) {
                  newzoo = value;
                  if (value != 0) {
                    newzooChange = computePrecentChange(value, preValue);
                  }
                } else if (v.rank_key.toLowerCase().indexOf('trending') != -1) {
                  trending = value;
                  if (value != 0) {
                    trendingChange = value - preValue;
                  }
                } else if (v.rank_key.toLowerCase().indexOf('sellers') != -1) {
                  sellers = value;
                  if (value != 0) {
                    sellersChange = value - preValue;
                  }
                } else if (v.rank_key.toLowerCase().indexOf('popular') != -1) {
                  popular = value;
                  if (value != 0) {
                    popularChange = value - preValue;
                  }
                }
              });
            }
            const obj = {
              rank: item.rank,
              name: item.name,
              gameIcon: item.cover,
              conutryFlag: item.country_img,
              conutryName: `${item.location_city} ,${item.location_country}`,
              mscience,
              mscienceChange,
              newzoo,
              newzooChange,
              trending,
              trendingChange,
              sellers,
              sellersChange,
              popular,
              popularChange,
              msRevenueTips,
              newzooTips,
              trendingTips,
              sellerTips,
              epicTips,
              id: item.app_id,
              countryId: history.location.query.marketNameEn,
              desc: item.publisher,
            };
            tempData.push(obj);
          } else if (param.entity_type == 'console') {
            // riser_tips处理
            const psDownloadTips = [];
            const psSellingTips = [];
            const xboxPlayTips = [];
            const xboxNewTips = [];
            const riserTips = item.big_riser_tips;
            if (riserTips) {
              riserTips.map((v) => {
                if (v.chart_type.toLowerCase().indexOf('playstation most downloaded') != -1) {
                  psDownloadTips.push(v.rank_type);
                } else if (
                  v.chart_type.toLowerCase().indexOf('playstation ps4 best selling') != -1
                ) {
                  psSellingTips.push(v.rank_type);
                } else if (v.chart_type.toLowerCase().indexOf('xbox most played') != -1) {
                  xboxPlayTips.push(v.rank_type);
                } else if (v.chart_type.toLowerCase().indexOf('xbox new release') != -1) {
                  xboxNewTips.push(v.rank_type);
                }
              });
            }
            // 处理 playstation most downloaded、playstation ps4 best selling、xbox most played、xbox new release 的数据及环比
            let psDownload = 0;
            let psDownloadChange = 0;
            let psSelling = 0;
            let psSellingChange = 0;
            let xboxPlay = 0;
            let xboxPlayChange = 0;
            let xboxNew = 0;
            let xboxNewChange = 0;

            const rankInfo = item.big_riser_rank;
            if (rankInfo) {
              const preRankInfo = item.pre_big_riser_rank;
              rankInfo.map((v) => {
                const value = v.rank_value;
                let preValue = 0;
                preRankInfo?.map((o) => {
                  if (o.rank_key == v.rank_key) {
                    preValue = o.rank_value;
                  }
                });
                if (v.rank_key?.toLowerCase().indexOf('playstation most downloaded') != -1) {
                  psDownload = value;
                  if (value != 0) {
                    psDownloadChange = value - preValue;
                  }
                } else if (
                  v.rank_key?.toLowerCase().indexOf('playstation ps4 best selling') != -1
                ) {
                  psSelling = value;
                  if (value != 0) {
                    psSellingChange = value - preValue;
                  }
                } else if (v.rank_key?.toLowerCase().indexOf('xbox most played') != -1) {
                  xboxPlay = value;
                  if (value != 0) {
                    xboxPlayChange = value - preValue;
                  }
                } else if (v.rank_key?.toLowerCase().indexOf('xbox new release') != -1) {
                  xboxNew = value;
                  if (value != 0) {
                    xboxNewChange = value - preValue;
                  }
                }
              });
            }

            const obj = {
              rank: item.rank,
              name: item.name,
              gameIcon: item.cover,
              conutryFlag: item.country_img,
              conutryName: `${item.location_city} ,${item.location_country}`,
              psDownload,
              psDownloadChange,
              psSelling,
              psSellingChange,
              xboxPlay,
              xboxPlayChange,
              xboxNew,
              xboxNewChange,

              psDownloadTips,
              psSellingTips,
              xboxPlayTips,
              xboxNewTips,
              desc: item.publisher,

              platList: item.platform?.split('|') || [],
              id: item.app_id,
              countryId: history.location.query.marketNameEn,
            };
            tempData.push(obj);
          }
        });
        if (bigRiserRes && bigRiserRes.date && flag) {
          changeDefaultTime(bigRiserRes.date);
          setRiserTime(bigRiserRes.date);
        }
      }
      setRiserData(tempData);
      setRiserLoad(false);
    } catch (error) {}
  };

  // New Release 数据查询
  const newReleaseSearch = async (param: any, flag = true) => {
    setReleaseLoad(true);
    const releaseRes = await getPageData('detail/insights_new_release', param);
    const tempData = [];
    if (releaseRes) {
      if (param.entity_type == 'mobile') {
        const releaseGames = formatMobileNewReleaseGames(releaseRes?.new_release_mobile_games, param?.market);
        releaseGames.forEach((releaseGame) => {
          tempData.push(releaseGame);
        });
      } else if (param.entity_type == 'pc') {
        const releaseDataT = releaseRes.new_release_pc_games;
        if (releaseDataT) {
          releaseDataT.map((item) => {
            const pcu = item.pcu || 0;
            const prePcu = item.pre_pcu || 0;
            const pcuChange = computePrecentChange(pcu, prePcu);
            const trending = item.news_trending || 0;
            const preTrending = item.pre_news_trending || 0;
            const trendingChange = trending - preTrending;
            const obj = {
              rank: item.rank,
              name: item.name,
              gameIcon: item.cover,
              conutryFlag: item.country_img,
              conutryName: `${item.location_city} ,${item.location_country}`,
              pcu,
              pcuChange,
              heat: item.heat,
              trending,
              trendingChange,
              relaseDate: item.release_date,
              id: item.app_id,
              countryId: history.location.query.marketNameEn,
              desc: item.publisher,
            };
            tempData.push(obj);
          });
        }
      } else if (param.entity_type == 'console') {
        const releaseDataT = releaseRes.new_release_console_games;
        if (releaseDataT) {
          releaseDataT.map((item) => {
            const newGame = item.new_games || 0;
            const preNewGame = item.pre_new_games || 0;
            const newGameChange = newGame - preNewGame;
            const newRelease = item.new_release || 0;
            const preNewRelease = item.pre_new_release || 0;
            const newReleaseChange = newRelease - preNewRelease;
            const obj = {
              rank: item.rank,
              name: item.name,
              gameIcon: item.cover,
              conutryFlag: item.country_img,
              conutryName: `${item.location_city} ,${item.location_country}`,
              newGame,
              newGameChange,
              heat: item.heat,
              newRelease,
              newReleaseChange,
              relaseDate: item.release_date,
              platList: item.platform?.split('|') || [],
              id: item.app_id,
              countryId: history.location.query.marketNameEn,
              desc: item.publisher,
            };
            tempData.push(obj);
          });
        }
      }
      if (releaseRes && releaseRes.date && flag) {
        changeDefaultTime(releaseRes.date);
        setReleaseTime(releaseRes.date);
      }
    }
    setReleaseData(tempData);
    setReleaseLoad(false);
  };

  // Upcoming 数据查询
  const upcomingSearch = async (param: any, flag = true) => {
    setUpcomingLoad(true);
    const upcomingRes = await getPageData('detail/insights_upcomming', param);
    let tempData = [];
    if (upcomingRes && upcomingRes.up_comming_games) {
      tempData = upcomingRes.up_comming_games;
      if (upcomingRes && upcomingRes.date) {
        changeDefaultTime(upcomingRes.date);
        setUpcomingTime(upcomingRes.date);
      } else {
        if (flag) {
          setUpcomingTime(moment().format('YYYY-MM-DD'));
        }
      }
    }
    if (tempData.length > 0) {
      tempData.map((item: any) => {
        item.countryId = history.location.query.marketNameEn;
      });
    }
    setUpcomingData(tempData);
    setUpcomingLoad(false);
  };

  const dataSearch = (param: any) => {
    cr10TrendSearch(param);
    bigRiserSearch(param);
    newReleaseSearch(param);
    upcomingSearch(param);
  };

  const onChangeRangePicker2 = (value: any, flag = false) => {
    const _params = {
      market: countryId,
      entity_type: SegmentValue,
      start_date: value.format('YYYY-MM-DD'),
      end_date: value.format('YYYY-MM-DD'),
      source: dataSource || '',
    };
    const a = timeCache;
    a[SegmentValue] = value.format('YYYY-MM-DD');
    setTimeCache({
      ...a,
    });

    setUpcomingTime(value.locale('en').format('MMM DD,YYYY'));
    setReleaseTime(value.locale('en').format('MMM DD,YYYY'));
    setRiserTime(value.locale('en').format('MMM DD,YYYY'));
    setTrendTime(value.locale('en').format('YYYY-MM-DD'));

    dateValue.length = 0;
    dateValue.push(...[value.format('YYYY-MM-DD')]);
    setDateValue(dateValue);

    cr10TrendSearch(_params, flag);
    bigRiserSearch(_params, flag);
    newReleaseSearch(_params, flag);
    upcomingSearch(_params, false);
  };

  const onChangeDataSource = (value: string) => {
    const [date] = dateValue || [];
    const params = {
      market: countryId,
      entity_type: SegmentValue,
      start_date: date || '',
      end_date: date || '',
      source: value || '',
    };

    /**
     * 目前DataSource切换只影响Market CR10 By Revenue模块
     * 目前仅Market CR10 By Revenue模块的接口入参有DataSource
     */
    cr10TrendSearch(params);
    // bigRiserSearch(params);
    // newReleaseSearch(params);
    // upcomingSearch(params);
    setDataSource(value);
  };

  // 窗口变化调整布局
  const resizeHandler = () => {
    const mapChartDom = document.getElementById('lineChart');
    if (mapChartDom) {
      const myMapChart = echarts.init(mapChartDom);
      try {
        myMapChart.resize();
      } catch (e) {}
    }
  };

  return {
    dataSearch,
    resizeHandler,
    lineData,
    cr10DetailSearch,
    SegmentValue,
    setSegmentValue,
    setTrendTime,
    gameTop101,
    gameTop102,
    trendLoad,
    trendLoadDetail,
    trendTime,
    hasLineData,
    hasCr10Data,
    riserTime,
    riserData,
    riserLoad,
    relaseTime,
    relaseData,
    relaseLoad,
    upcomingTime,
    upcomingData,
    upcomingLoad,
    timeCache,
    setUpcomingTime,
    setReleaseTime,
    setRiserTime,
    dateValue,
    setDateValue,
    cr10TrendSearch,
    bigRiserSearch,
    newReleaseSearch,
    upcomingSearch,
    onChangeRangePicker2,
    onChangeDataSource,
    dataSource,
    lineChartDate,
  };
}
